export const FILTER = 'branches/filter/FILTER'
export const FILTER_REQUEST = 'branches/filter/FILTER_REQUEST'
export const FILTER_FAIL = 'branches/filter/FILTER_FAIL'
export const FILTER_SUCCESS = 'branches/filter/FILTER_SUCCESS'
export const FILTER_RESET = 'branches/filter/FILTER_RESET'